import { render, staticRenderFns } from "./FavElement.vue?vue&type=template&id=341a3ea6&"
import script from "./FavElement.vue?vue&type=script&lang=js&"
export * from "./FavElement.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('341a3ea6')) {
      api.createRecord('341a3ea6', component.options)
    } else {
      api.reload('341a3ea6', component.options)
    }
    module.hot.accept("./FavElement.vue?vue&type=template&id=341a3ea6&", function () {
      api.rerender('341a3ea6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-4OfNen6H71g7H/JS/comp/FavElement.vue"
export default component.exports